import _inheritsLoose from "@babel/runtime/helpers/esm/inheritsLoose";
import React from 'react';
import { ThemeContext } from "../../../lib/theming/ThemeContext";
import { CommonWrapper } from "../../../internal/CommonWrapper";
import { cx } from "../../../lib/theming/Emotion";
import { styles } from "../SidePage.styles";
import { SidePageContext } from "../SidePageContext";
/**
 * Контейнер с отступами
 *
 * @visibleName SidePage.Container
 */

export var SidePageContainer = /*#__PURE__*/function (_React$Component) {
  _inheritsLoose(SidePageContainer, _React$Component);

  function SidePageContainer() {
    var _this;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _React$Component.call.apply(_React$Component, [this].concat(args)) || this;
    _this.theme = void 0;
    return _this;
  }

  var _proto = SidePageContainer.prototype;

  _proto.render = function render() {
    var _this2 = this;

    return /*#__PURE__*/React.createElement(ThemeContext.Consumer, null, function (theme) {
      _this2.theme = theme;
      return _this2.renderMain();
    });
  };

  _proto.renderMain = function renderMain() {
    var _this3 = this;

    return /*#__PURE__*/React.createElement(SidePageContext.Consumer, null, function (_ref) {
      var _cx;

      var hasHeader = _ref.hasHeader,
          hasFooter = _ref.hasFooter,
          hasPanel = _ref.hasPanel;
      return /*#__PURE__*/React.createElement(CommonWrapper, _this3.props, /*#__PURE__*/React.createElement("div", {
        className: cx((_cx = {}, _cx[styles.container(_this3.theme)] = true, _cx[styles.containerWithoutHeader(_this3.theme)] = !hasHeader, _cx[styles.containerWithoutFooter(_this3.theme)] = !hasFooter, _cx[styles.containerWithPanel(_this3.theme)] = hasPanel, _cx))
      }, _this3.props.children));
    });
  };

  return SidePageContainer;
}(React.Component);
SidePageContainer.__KONTUR_REACT_UI__ = 'SidePageContainer';